<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container md="12">
      <v-row dense>
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-text-field type="text" label="機關團體名稱" dense clearable class="font-weight-normal" v-model="queryObject.mainDeptName" @input="getInterpreterFromServer"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-text-field type="text" label="姓名" dense clearable class="font-weight-normal" v-model="queryObject.name" @input="getInterpreterFromServer"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-text-field type="text" label="帳號" dense clearable class="font-weight-normal" v-model="queryObject.account" @input="getInterpreterFromServer"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-select :items="getCodeDateUtil('accountStatus')" label="帳號狀態" dense clearable class="font-weight-normal" v-model="queryObject.status" @change="getInterpreterFromServer"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="pageSize"
            :loading="loading"
            :footer-props="{ itemsPerPageText:'每頁筆數' }"
            class="elevation-1"
            widths="1500"
            no-data-text="無資料"
            loading-text="資料傳輸中"
            hide-default-footer
            multi-sort
          >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>
              <v-row class="pa-3 ma-5" align="center" justify="center">
                <v-col>
                <span class="red--text">共 {{totalCount}} 筆，每頁筆數</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn dark text color="red" class="ml-2" v-on="on">
                      {{ itemsPerPage }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(number, index) in itemsPerPageArray"
                      :key="index"
                      @click="updateItemsPerPage(number)"
                    >
                      <v-list-item-title>{{ number }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                </v-col>
              </v-row>
              </v-toolbar-title>

              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" persistent max-width="1024" >
                <v-card>
                    <v-card-title class="red" dark>
                      <h2>
                        <font style="color:white">修改</font>
                      </h2>
                    </v-card-title>
      
                  <v-card-text>
                    <v-container>
                      <v-row dense>
                        <v-col cols="12" sm="6" md="4" offset-md="1">
                        <v-select :items="getCodeDateUtil('accountType')" label="使用者類別" dense v-model="editedItem.type" disabled></v-select>
                        <v-checkbox v-model="editedItem.domain" v-if="editedItem.type === 'AAA'" label="是否有開設通譯培訓課程" disabled dense></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" offset-md="1" v-show="editedItem.type != 'CCC'" >
                        <v-text-field v-model="editedItem.mainDeptId" label="機關代號或統一編號" disabled dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" offset-md="1" v-show="editedItem.type != 'CCC'" >
                        <v-text-field v-model="editedItem.mainDeptName" label="機關名稱" disabled dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" offset-md="1" v-show="editedItem.type != 'CCC'" >
                        <v-text-field v-model="editedItem.name" label="使用者姓名" disabled dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" offset-md="1" v-show="editedItem.type === 'CCC'" >
                        <v-text-field v-model="editedItem.name" label="姓名" disabled dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" offset-md="1">
                        <v-text-field v-model="editedItem.account" label="帳號" disabled dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" offset-md="1">
                        <v-text-field 
                          id="password"
                          label="密碼"
                          :append-icon="showPassword1 ? 'visibility_off' : 'visibility'"
                          :type="showPassword1 ? 'text' : 'password'"
                          @click:append="showPassword1 = !showPassword1"
                          v-model="pw"
                          clearable
                          counter
                          maxlength="20"
                          dense
                          class="font-weight-normal"
                          :rules="pwRules"
                        ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" offset-md="1">
                        <v-select :items="getCodeDateUtil('accountStatus')" label="帳號狀態" v-model="editedItem.status" dense ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" offset-md="1">
                        <v-select multiple  :items="getCodeDateUtil('ugrpGroup')" label="權限群組" v-model="ugrpIdArray" dense :rules="selectRequiredRules"> </v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-3" style="color:black;" @click="canceldata();">取消</v-btn>
                    <v-btn color="red" style="color:white;" @click="savedata" :disabled="(!valid)"  >儲存</v-btn>
                  </v-card-actions>
                </v-card>   
              </v-dialog>  
            </v-toolbar>
          </template>
            <template v-slot:item.status="{ item }">
              {{getColor(item.status)}}
            </template>
            <template v-slot:item.type="{ item }">
              {{getColor(item.type)}}
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                  class="mr-2"
                  @click="editItem(item)"
                >
                  edit
                </v-icon>
              <v-icon
                @click="deleteItem(item)"
              >
                delete
              </v-icon>
            </template>

            <template v-slot:footer>
              <div class="text-center pa-2 ma-2">
                <v-pagination 
                  color="red"
                  v-model="currentPage" 
                  :length="maxPage" 
                  :total-visible="9"
                  @input="getInterpreterFromServer()"
                ></v-pagination>
              </div>
            </template>

          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
  },
  computed: {
    ...mapGetters({
      getTargetCaseId: ["getTargetCaseId"],
      idbServerUrl: ["getIdbServerUrl"]
    }),
  },
  data() {
    return {
      valid: false,
      pw: 'originalPW99',
      showPassword1: false,
      pwRules: [
        //  特殊符號 (?=.*[^a-zA-Z0-9])
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20",
        v => /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/.test(v) || "密碼強度需 6 位數以上，並且至少包含大寫字母、小寫字母、數字各一"
      ],
      requiredRules: [v => !!v || "此欄位是必填"],
      selectRequiredRules: [v => v.length != 0 || "此欄位是必填"],
      editedItem: {
        type: '',
        domain: '',
        mainDeptId: '',
        mainDeptName: '',
        name: '',
        account: '',
        status: '',
      },
      defaultItem: {
        type: '',
        domain: '',
        mainDeptId: '',
        mainDeptName: '',
        name: '',
        account: '',
        status: '',
      },
      finalObject: [],
      ugrpIdArray: [],
      editedIndex: -1,
      dialog: false,
      loading: false,
      options: {},
      items: [],
      queryObject: {},
      queryPager: {
        pageSize: 10,
        currentPage: 1,
        sortColumnNameList: ["-createDate"]
      },
      itemsPerPageArray: [5,10,30,50],
      currentPage:1,
      itemsPerPage: 10,
      maxPage:0,
      pageSize:10,
      totalCount:0,
      criterion: {},
      headers: [
        { text: "使用者類別", value: "type"   },
        { text: "機關團體名稱", value: "showDept"  },
        { text: "姓名", value: "name" },
        { text: "帳號", value: "account" },
        { text: "帳號狀態", value: "status" },
        { text: "動作", value: "action", sortable: false }
      ],

    };
  },
  watch: {
    options: {
      handler() {
       this.getInterpreterFromServer()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),
    
    getColor(value) {
     if (value == "AAA") {
        return "需求單位";
      }else if (value == "BBB") {
        return "培訓單位";
      }else if (value == "CCC") {
        return "通譯人員";
      }else if (value == "Y") {
        return "啟用";
      }else if (value == "N") {
        return "停用";
      }else if (value == "W") {
        return "待審核";
      }else{
        return value;
      }
    },

    editItem (item) {
      var vm = this;
      this.editedIndex =item.uuid
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      vm.ugrpIdArray = [];
      vm.axios
        .get(
          vm.idbServerUrl + "idb/auth/AuthRoleTarget/" +
            item.uuid,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          vm.items2 = response.data.resultList
          for (var i = 0; i < vm.items2.length; i++) {
            vm.ugrpIdArray.push(vm.items2[i].roleId);
          }
        })
        .catch(function(error) {
          vm.handErrorUtil(error.response.status);
          //console.log("!!!! " + error);
        });
    },
    deleteItem (item) {
      if (confirm('確定要刪除帳號'+ item.account +'嗎?')) {
        console.log("delete Item " + item.uuid);
        var vm = this;
        vm.axios
          .delete(
            vm.idbServerUrl + "idb/member/memberAccount/" +
              item.uuid,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: vm.$localStorage.get("idb_login_token")
              }
            }
          )
          .then(function(response) {
            console.log("response " + JSON.stringify(response));
            //vm.successSwalUtil();
            vm.delSuccessSwalUtil();
            vm.getInterpreterFromServer();
          })
          .catch(function(error) {
            vm.handErrorUtil(error.response.status);
            //console.log("!!!! " + error);
          });
      } else {
        console.log("delete canceled" + item.uuid);
      }
    },
    canceldata () {
      this.dialog = false;
      this.pw = "originalPW99";
      this.showPassword1 = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300)
    },
    savedata () {
      var vm = this;

      var objTmpUgrp={}
      vm.finalObject=[]
      if (vm.ugrpIdArray != null && vm.ugrpIdArray.length != 0) {
        for (var i = 0; i < vm.ugrpIdArray.length; i++) {
            objTmpUgrp = {
              roleId: vm.ugrpIdArray[i],
              targetId: vm.uuid
            };
            vm.finalObject.push(objTmpUgrp);
        }
      }

      if ( vm.pw != "" && vm.pw != "originalPW99") {
        vm.editedItem.password = vm.pw;
      }
      var data = {
        authRoleTargetList:vm.finalObject,
        memberAccount:vm.editedItem
      };

      vm.axios
        .put(vm.idbServerUrl + "idb/member/memberAccount", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: vm.$localStorage.get("idb_login_token")
          }
        })
        .then(function(response) {
          console.log("response\n" + JSON.stringify(response));
          vm.successSwalUtil();
          vm.getInterpreterFromServer();
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
        vm.canceldata()
    },

    updateItemsPerPage(number) {
      this.itemsPerPage = number;
      this.getInterpreterFromServer();
    },

    getInterpreterFromServer() {
      var vm = this;
      vm.loading = true;
      const { sortBy, sortDesc } = this.options

      var sortColumnNameList = ["-createDate"]
      sortBy.forEach((element, index) => {
        sortColumnNameList[index] = (sortDesc[index] ? "-" : "") + element;
      });
      
      var queryObjectStr = JSON.stringify(vm.queryObject)

      var queryPagerStr = JSON.stringify({
        pageSize: vm.itemsPerPage,
        currentPage: vm.currentPage,
        sortColumnNameList: sortColumnNameList
      });
      var criterionStr = JSON.stringify({});
      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/member/memberAccount?queryString=" +
            encodeURIComponent(queryObjectStr) +
            "&queryPager=" +
            encodeURIComponent(queryPagerStr) +
            "&criterion=" +
            encodeURIComponent(criterionStr),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          //var dataResponse = JSON.stringify(response.data.resultList)
          //console.log(JSON.stringify(response))
          vm.currentPage = response.data.currentPage;
          vm.maxPage = response.data.maxPage;
          vm.pageSize = response.data.pageSize;
          vm.totalCount = response.data.totalCount;
          vm.items = response.data.resultList;

          for (var i = 0; i < vm.items.length; i++) {
            vm.items[i].showDept = vm.items[i].mainDeptName;
            if (vm.items[i].type === "CCC") {
              vm.items[i].showDept = "";
            }
          }

          vm.loading = false;
          this.$refs.form.validate();
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    }
  
  },
  mounted() {
    var vm = this;
    vm.getInterpreterFromServer();
    //this.$refs.form.validate();
  }
};
</script>




